// extracted by css-extract-rspack-plugin
export default {"cls1":"SimpleResultsView-cls1_Opt","cls2":"SimpleResultsView-cls2_F0H SimpleResultsView-cls1_Opt"};